/* rk-pack-price (21 Oct 2026, Alexander): the product page price reads "$84 - 3 Pack" / "$63 - 2 Pack" for the selected pack.
   Loaded by snippets/quantity-breaks.liquid, so it only runs on products with packs. The price block is redrawn by the theme on
   colour/pack changes, so the name is re-applied whenever the price changes (MutationObserver) or a pack is picked.
   22 Oct 2026: every buy box on the page gets it (landing pages have two featured-product boxes; the second showed "$84" alone). */
(function () {
  if (window.rkPackPrice) return; window.rkPackPrice = 1;
  function boxes() { var l = [].slice.call(document.querySelectorAll('.main-product__info-container')); return l.length ? l : [document]; }
  function packName(root) {
    var qb = root.querySelector('quantity-breaks'); if (!qb) return '';
    var inp = qb.querySelector('input[name="quantity"]:checked'); if (!inp) return '';
    var lab = qb.querySelector('label[for="' + inp.id + '"] .quantity-break__label-text');
    return lab ? lab.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function apply() { boxes().forEach(applyOne); }
  function applyOne(root) {
    var name = packName(root), box = root.querySelector('.price'); if (!box) return;
    var shown = [].filter.call(box.querySelectorAll('.price-item'), function (e) { return e.offsetParent !== null && /\d/.test(e.textContent); })[0];
    var tag = box.querySelector('.rk-pack-name');
    if (!name || !shown) { if (tag) tag.remove(); return; }
    if (!tag) { tag = document.createElement('span'); tag.className = 'rk-pack-name'; }
    if (tag.previousElementSibling !== shown) shown.after(tag);
    var t = ' - ' + name; if (tag.textContent !== t) tag.textContent = t;
    /* same font as the price itself (the .price box is the body font; the price item carries the serif price style per breakpoint) */
    var cs = getComputedStyle(shown);
    ['fontFamily', 'fontSize', 'fontWeight', 'letterSpacing', 'lineHeight', 'color'].forEach(function (k) { if (tag.style[k] !== cs[k]) tag.style[k] = cs[k]; });
  }
  function boot() {
    apply();
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') setTimeout(apply, 30); });
    boxes().forEach(function (root) {
      var box = root.querySelector('.price');
      var host = box && (box.closest('[id^="price-"]') || box.parentElement);
      if (host && window.MutationObserver) new MutationObserver(function () { applyOne(root); }).observe(host, { childList: true, subtree: true, characterData: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
